import {
  NightingaleFilters,
  NightingaleResponse,
} from "@/reports/types/NightingaleResponse.interface";
import { AdminVenue } from "./AdminVenue.enum";

export enum HighlightType {
  view_count = "view_count",
  teacher_assignment_count = "teacher_assignment_count",
  quiz_count = "quiz_count",
}

export interface HighlightCard {
  highlightType: HighlightType;
  title: string;
  tooltipCopy: string;
  index: number;
  list?: Array<{
    label: string;
    value: number;
    href?: string;
  }>;
  metric: string;
}

export const highlightCards: HighlightCard[] = [
  {
    highlightType: HighlightType.quiz_count,
    title: "Quizzes submitted",
    tooltipCopy:
      "Shows the top three schools, within your selected filters, where students completed the most quizzes.",
    index: 2,
    metric: "quizzes",
  },
  {
    highlightType: HighlightType.view_count,
    title: "Articles viewed",
    tooltipCopy:
      "Shows the top three schools, within your selected filters, where students viewed the most articles at the header level. Articles read at multiple reading levels are not counted multiple times here.",
    index: 0,
    metric: "views",
  },
  {
    highlightType: HighlightType.teacher_assignment_count,
    title: "Assignments created",
    tooltipCopy:
      "Shows the top three schools, within your selected filters, with the highest number of article assignments created.",
    index: 1,
    metric: "assigns",
  },
];

export interface SchoolHighlightData {
  school_name: string;
  school_unique_id: string;
  count: number;
}

export interface TeacherHighlightData {
  teacher_name: string;
  teacher_unique_id: string;
  count: number;
}

export interface EngagementHighlightsDataEntities {
  [HighlightType.quiz_count]: SchoolHighlightData[] | TeacherHighlightData[];
  [HighlightType.view_count]: SchoolHighlightData[] | TeacherHighlightData[];
  [HighlightType.teacher_assignment_count]:
    | SchoolHighlightData[]
    | TeacherHighlightData[];
}

export interface EngagementHighlightsDataFilters extends NightingaleFilters {
  entity_type: AdminVenue;
  entity_filter_type?: AdminVenue;
  entity_grade_level?: string | undefined;
}

export type EngagementHighlightsDataResponse =
  | NightingaleResponse<
      {
        entities: EngagementHighlightsDataEntities;
        total_items: number;
      },
      EngagementHighlightsDataFilters
    >
  | undefined;
